import { ListGroup } from "reactstrap";
import { PropsWithChildren } from "react";
import { EntryCheckbox } from "./EntryCheckbox";
import { EntryContent } from "./EntryContent";

interface Props {
  identifier: string;
  dataCy: string;
  toggleSelection: (identifier: string) => void;
  isSelected: boolean;
  to?: string;
  onClick?: () => void;
}

export function Entry({
  identifier,
  dataCy,
  children,
  toggleSelection,
  isSelected,
  to,
  onClick,
}: PropsWithChildren<Props>) {
  return (
    <ListGroup
      horizontal
      className="border-top rounded-0"
      style={{ flex: "1 1 auto" }}
      data-cy={dataCy}
      data-cy-key={identifier}
    >
      <EntryCheckbox
        identifier={identifier}
        toggleSelection={toggleSelection}
        isSelected={isSelected}
      />
      <EntryContent isSelected={isSelected} to={to} onClick={onClick}>
        {children}
      </EntryContent>
    </ListGroup>
  );
}
